(function ($) {
  const SHOW_ON_SELECTED_COUNT = 2;

  function visualFiltering() {
    $(".symptomsfilter").each(function () {
      var parentThis = $(this);

      parentThis.find(".form-ui input").each(function (item) {
        $(this).attr("checked", false);
      });

      var filters = [];
      parentThis.find(".form-ui input").on("change", function () {
        var valueOfThis = $(this).data("filter-value");
        if (filters.includes(valueOfThis)) {
          filters = filters.filter((item) => item !== valueOfThis);
        } else {
          filters.push(valueOfThis);
        }
        showElements();
      });

      function showElements() {
        parentThis
          .find(".containerfilter")
          .find(".item")
          .each(function () {
            var localThis = $(this);
            var filterWith = localThis.data("filter-with").split(",");

            var hasItem = false;

            filterWith.forEach(function (item) {
              if (filters.includes(item.trim())) {
                hasItem = true;
              }
            });

            if (hasItem && filters.length >= SHOW_ON_SELECTED_COUNT) {
              localThis.fadeIn();
              var timer = setTimeout(function () {
                localThis.find(".load-3").fadeOut(800);
              }, 2000);
            } else {
              localThis.fadeOut();
              var timer = setTimeout(function () {
                localThis.find(".load-3").fadeIn(800);
              }, 810);
            }
          });
      }

      showElements();
    });
  }

  visualFiltering();

  $('[data-toggle="tab"]').on("click", function () {
    $(".tab-pane").find(".load-3").fadeIn(600);
    setTimeout(function () {
      $(".tab-pane.show").find(".load-3").fadeOut(600);
    }, 300);
    
   $(".tab-pane").find('.hiddencobtn').fadeOut(); 
      setTimeout(function(){
              $(".tab-pane.show").find('.hiddencobtn').fadeIn(); 
          }, 20000);
    });
  
})(jQuery);
